skyward.base.registerScript("parametermapper", function (skyward, $)
{
    "use strict";
    skyward.parametermapper = skyward.parametermapper || {};

    var initParameterMappers = function (selector)
    {
        const jQSelector = $(selector);
        jQSelector.find('.parametermapperworkflowversionhidden').each(function ()
        {
            const hidden = $(this);
            hidden.off("change", skyward.parametermapper.workflowVersionChanged);
            hidden.on("change", skyward.parametermapper.workflowVersionChanged);

            const parameterMapper = hidden.siblings(".parametermapper");
            togglePromptInstructions(parameterMapper);
        });

        if (jQSelector.hasClass("parametermapper"))
        {
            togglePromptInstructions(jQSelector);
        }
    };

    var getDetailLineValue = function (fieldSetWrapper)
    {
        fieldSetWrapper = fieldSetWrapper instanceof $ ? fieldSetWrapper : $(fieldSetWrapper);
        var input = fieldSetWrapper.find('.parametermapper-input');
        var data =
        {
            rowID: fieldSetWrapper.attr("id"),
            inputID: input.attr("id"),
            parameterName: input.data('parametermapperInputParameterName'),
            boundValue: input.data('parametermapperInputBackingValue'),
            displayValue: skyward.controls.getValue(input),
        };

        return data;
    }

    var setDetailLineValue = function (data)
    {
        var rowID = data.rowID;
        var inputID = data.inputID;
        var boundValue = data.boundValue;
        var displayValue = data.displayValue;

        var control;
        if (inputID !== undefined)
        {
            control = $('#' + inputID);
        }
        else if (rowID !== undefined)
        {
            control = $('#' + rowID).find('.parameter-mapper-input');
        }

        if (control)
        {
            control.data('parametermapperInputBackingValue', boundValue);
            skyward.controls.setValue(control, displayValue);
        }
    }

    skyward.parametermapper.getValue = function (parameterMapper)
    {
        parameterMapper = parameterMapper instanceof $ ? parameterMapper : $(parameterMapper);

        var detailData = [];
        var detailWrappers = parameterMapper.find('.parametermapperdetail');
        if (detailWrappers)
        {
            detailWrappers.each(function () { detailData.push(getDetailLineValue(this)); })
        }

        var fullData =
        {
            parameterbucketid: parameterMapper.data('parameterbucketid'),
            processversionid: parameterMapper.data('processversionid'),
            workflowversionid: parameterMapper.data('workflowversionid'),
            subjecttypecode: parameterMapper.data('subjecttypecode'),
            mappings: detailData
        }

        return JSON.stringify(fullData);
    }

    skyward.parametermapper.setValue = function (jsonString)
    {
        // Parse- and iterate calling setDetailLineValue
    }

    skyward.parametermapper.addPrompt = async function ()
    {
        const button = $(this);
        const data = button.data();

        const prompt = await skyward.promptBuilder.buildPopup(data.isrequired,
            data.datatypecode,
            data.inputtype,
            data.promptguid,
            data.parameterdisplayname,
            data.schemafielduniqueid,
            data.schemaobjectuniqueid,
            data.schemamodule,
            data.schemaobject,
            data.schemafield,);
        if (prompt)
        {
            savePrompt(prompt, data, button);
        }
    }

    const savePrompt = function (prompt, data, button)
    {
        const parameterInput = $("#" + data.inputid);
        const promptsHiddenBackingData = parameterInput.parents(".skywardContentPanel").find(".prompts");
        const promptsArray = promptsHiddenBackingData.val() !== '' ? JSON.parse(promptsHiddenBackingData.val()) : [];
        if (prompt.filterJson)
        {
            prompt.filterJson = window.skyward.extensions.encodeHtml(prompt.filterJson);
        }
        promptsArray.push(prompt);
        promptsHiddenBackingData.val(JSON.stringify(promptsArray));

        setDetailLineValue({
            inputID: data.inputid,
            boundValue: "{_prompt." + prompt.promptGuid + "}",
            displayValue: prompt.displayName
        });
        skyward.modalLayer.getLayerFromElement(button).close();
        togglePromptInstructions(parameterInput.parents(".parametermapper"));
    }

    const togglePromptInstructions = function (parametermapper)
    {
        const parametermapperValueJson = skyward.parametermapper.getValue(parametermapper);
        const parameterMapperValue = JSON.parse(parametermapperValueJson);
        let hasPrompts = parameterMapperValue.mappings.some(function (parameterMapping)
        {
            const boundValue = parameterMapping.boundValue;
            return typeof (boundValue) === 'string' && boundValue.toLowerCase().startsWith('{_prompt.');
        });

        parametermapper.siblings(".promptInstructions").css("display", hasPrompts ? "block" : "none");
    }

    var shouldHideSubjectBindings = function(parameterMapperPart)
    {
        var taskElementContainer = parameterMapperPart.closest("tr");
        var hideSubjectBindings = parameterMapperPart.data().checkForSubject;
        if (hideSubjectBindings)
        {
            var atLeastOneTaskElementBeforeMe = false;
            taskElementContainer.prevAll("tr:visible").each(function ()
            {
                atLeastOneTaskElementBeforeMe = true;
                var previousTaskElementType = skyward.controls.getValue($(this).find(".cboTypeCode"));
                if (previousTaskElementType === 'S')
                {
                    hideSubjectBindings = false;
                    return false;
                }
            });

            hideSubjectBindings = atLeastOneTaskElementBeforeMe ? hideSubjectBindings : true;
        }
        return hideSubjectBindings;

    }

    skyward.parametermapper.workflowVersionChanged = function ()
    {
        var workflowVersionHidden = $(this);
        var workflowVersionValue = skyward.controls.getValue(workflowVersionHidden);
        var hiddenDataz = workflowVersionHidden.data();
        var sourceId = workflowVersionHidden.attr("id");
        var parameterMapperId = sourceId.replace(hiddenDataz.originalId, hiddenDataz.originalIdParameterMapper);
        var jqParameterMapperDiv = $("#" + parameterMapperId);
        var parameterMapperDiv = jqParameterMapperDiv[0];
        parameterMapperDiv.innerHTML = "";
        var existingValue = skyward.controls.getValue(parameterMapperDiv);
              
        var hideSubjectBindings = shouldHideSubjectBindings(workflowVersionHidden);

        $.ajax(skyward.global.virtualDir + hiddenDataz.changedArea + "/" + hiddenDataz.changedController + "/" + hiddenDataz.changedAction,
            {
                type: "POST",
                dataType: "JSON",
                data: {
                    workflowVersionId: workflowVersionValue,
                    targetId: parameterMapperId,
                    parameterMapperId: existingValue,
                    originalParameterMapperId: hiddenDataz.originalIdParameterMapper,
                    hideSubjectBindings: hideSubjectBindings,
                    processVersionID: hiddenDataz.processversionid,
                    processVersionIDToEdit: hiddenDataz.processversionidtoedit,
                    processVersionIDToClone: hiddenDataz.processversionidtoclone
                },
                success: async function (data)
                {
                    if (data.success)
                    {
                        var targetId = "#" + data.controlKey;
                        var targetDiv = $(targetId)[0];
                        const processedHtml = await skyward.global.processViewPartHtml(data.innerHtml);
                        targetDiv.innerHTML = processedHtml;
                        $(targetDiv).data('workflowversionid', data.workflowVersionId);
                        skyward.window.notifyDOMLoad(targetId);
                    }
                    else
                    {
                        skyward.modalLayer.showErrorDialog("Failed to update WorkflowVersionID", data.errorMessage);
                    }
                }
            });
    };

    skyward.parametermapper.selectParameter = function (button)
    {
        var jqButton = $(button);
        var data = jqButton.data();
        var parameterName = data.parametername;
        var workflowVersionID = data.workflowversionid;
        var hideSubjectBindings = data.subjecttypecode ? shouldHideSubjectBindings(jqButton) : true;
        var subjectTypeCode = hideSubjectBindings ? '' : data.subjecttypecode;
        var inputForResult = jqButton.parent().children(".parametermapper-input");
        var idOfInputForResult = inputForResult.attr("id");
        var buildPopup = function ()
        {
            return $.ajax(
                {
                    url: skyward.global.virtualDir + 'Workflow/ParameterMapping/SelectParameterDialog',
                    id: 'SelectParameterDialog',
                    type: 'POST',
                    dataType: 'HTML',
                    data:
                    {
                        parameterName: parameterName,
                        inputId: idOfInputForResult,
                        workflowVersionID: workflowVersionID,
                        subjectTypeCode: subjectTypeCode,
                        processVersionID: data.processversionid,
                        processVersionIDToClone: data.processversionidtoclone,
                        processVersionIDToEdit: data.processversionidtoedit,
                        optional: data.optional,
                        unsavedPrompts: jqButton.parents(".skywardContentPanel").find(".prompts").val(),
                    }
                });
        };
        skyward.modalLayer.showDialog("Select a Parameter Value", buildPopup, [close]);
    };

    skyward.parametermapper.clearParameter = function (button)
    {
        var inputForResult = $(button).parent().children(".parametermapper-input");
        var idOfInputForResult = inputForResult.attr("id");

        setDetailLineValue({
            inputID: idOfInputForResult,
            boundValue: "",
            displayValue: ""
        });
    };

    skyward.parametermapper.boundValue = function (button)
    {
        var data = $(button).data();

        setDetailLineValue({
            inputID: data.inputid,
            boundValue: data.binding,
            displayValue: data.friendlyname
        })
        skyward.modalLayer.getLayerFromElement($(button)).close();
        togglePromptInstructions($("#" + data.inputid).parents(".parametermapper"));
    };

    skyward.parametermapper.specificValue = function (button)
    {
        var data = $(button).data();
        var parameterName = data.parametername;
        var workflowVersionID = data.workflowversionid;

        var buildPopup = function ()
        {
            return $.ajax(
                {
                    url: skyward.global.virtualDir + 'Workflow/ParameterMapping/SpecificValueDialog',
                    id: 'SpecificValueDialog',
                    type: 'POST',
                    dataType: 'HTML',
                    data:
                    {
                        parameterName: parameterName,
                        workflowVersionID: workflowVersionID,
                    }
                });
        };
        var saveButton = {
            id: "saveButton", text: "Save", click: function ()
            {
                var control = dialog.container.find(".js-actualSpecificValue");

                setDetailLineValue(
                    {
                        inputID: data.inputid,
                        boundValue: skyward.controls.getValue(control),
                        displayValue: getSpecificValueFriendlyName(control)
                    });

                dialog.close();
                skyward.modalLayer.getLayerFromElement($(button)).close();
                togglePromptInstructions($("#" + data.inputid).parents(".parametermapper"));
            }, icon: "Save"
        };
        var cancelButton = { id: "cancelButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
        var dialog = skyward.modalLayer.showDialog("Enter Variable", buildPopup, [saveButton, cancelButton]);
        window.dialog = dialog;
    };

    var getSpecificValueFriendlyName = function (control)
    {
        if (control.is('.codeEELValue'))
        {
            var description = control.parent().find('.codeEELDescription').val();
            if (description !== undefined && description !== "")
            {
                return description;
            }
            var code = control.parent().find('.codeEELCode').val();
            if (code !== undefined && code !== "")
            {
                return code;
            }
            return null;
        }
        if (control.is('.comboBoxSet'))
        {
            var text = control.find(":selected").text();
            if (text !== undefined)
            {
                return text;
            }
            return null;
        }
        if (control.is('.tileViewEEL'))
        {
            var text = control.find(".tileViewEEL_search").val()
            if (text !== undefined)
            {
                return text;
            }
            return null;
        }

        if (control.is(".checkbox"))
        {
            return control.is(":checked") ? "True" : "False";
        }

        if (control.is("sky-datepicker,.datePicker"))
        {
            const date = skyward.controls.getValue(control);
            return date.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: '2-digit'
            });
        }

        return skyward.extensions.decodeHtml(skyward.controls.getValue(control));
    }

    skyward.window.registerLoadDOMCallback(initParameterMappers);
    return {
        addPrompt : skyward.parametermapper.addPrompt
    };
});